// extracted by mini-css-extract-plugin
export default {"avatar":"StaffIdentity_avatar__VVsGO","name":"StaffIdentity_name__PnSHd","subtitle":"StaffIdentity_subtitle__K6s+l"};